// extracted by mini-css-extract-plugin
export default {"container":"z3Li4KFPIQZ9TuO3j59o","list":"HYk0GNGgQNrxB_JrtgMA"};